import React from 'react'
import { Link } from 'react-router-dom'
import Still02 from "../assets/still-02.png";
import HeartLine from "../assets/heart-line.png";
import { useTranslation } from "react-i18next";

const HotelList = () => {
  const { t } = useTranslation();
  return (
    <>
    <div className="trip-details trip-review-details p-12 d-flex mb-3 flex-lg-nowrap flex-wrap">
      <div className="left-review-details d-flex flex-wrap gap-2">
        <div className="img-review">
          <img src={Still02} alt={t("hotelAlt")} />
        </div>
        <div className="text-review">
          <Link to="hotel-details.html" className="btn-details-sec">
            <h2>{t("hotelName")}</h2>
          </Link>
          <div className="heart-text d-flex align-items-center gap-2">
            <span>{t("hotelLocation")}</span>
          </div>
          <div className="btn-box-mid">
            <Link to="#" className="btn btn-parrot">
              {t("limitedDeal")}
            </Link>
          </div>
          <div className="room-details">
            <p>{t("roomType")}</p>
            <ul className="list-item-dot">
              <li>{t("bedType")}</li>
            </ul>
            <p>{t("paymentPolicy")}</p>
          </div>
        </div>
      </div>
      <div className="right-review-details">
        <div className="review-right-com d-flex flex-column h-100 text-end">
          <div className="top-box-review">
            <div className="room-servic">
              <span className="review-text">{t("reviewText")}</span>
              <span className="review-btn"></span>
            </div>
          </div>
          <span className="img mt-2 mb-3">
            <img src={HeartLine} width="25px" alt="favorite" />
          </span>
          <div className="bottom-box-price-details mt-auto">
            <div className="bottom-box">
              <ul className="top-adult list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li>{t("stayDuration")}, </li>
                <li>{t("guests")}</li>
              </ul>
              <ul className="price-details list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li className="old-price">₹ 3,306</li>
                <li className="current-price">₹ 1,587</li>
              </ul>
              <span>{t("taxesFees")}</span>
              <Link to="/hotel-details" className="btn btn-primary">
                {t("viewDetails")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="trip-details trip-review-details p-12 d-flex mb-3 flex-lg-nowrap flex-wrap">
      <div className="left-review-details d-flex flex-wrap gap-2">
        <div className="img-review">
          <img src={Still02} alt={t("hotelAlt")} />
        </div>
        <div className="text-review">
          <Link to="hotel-details.html" className="btn-details-sec">
            <h2>{t("hotelName")}</h2>
          </Link>
          <div className="heart-text d-flex align-items-center gap-2">
            <span>{t("hotelLocation")}</span>
          </div>
          <div className="btn-box-mid">
            <Link to="#" className="btn btn-parrot">
              {t("limitedDeal")}
            </Link>
          </div>
          <div className="room-details">
            <p>{t("roomType")}</p>
            <ul className="list-item-dot">
              <li>{t("bedType")}</li>
            </ul>
            <p>{t("paymentPolicy")}</p>
          </div>
        </div>
      </div>
      <div className="right-review-details">
        <div className="review-right-com d-flex flex-column h-100 text-end">
          <div className="top-box-review">
            <div className="room-servic">
              <span className="review-text">{t("reviewText")}</span>
              <span className="review-btn"></span>
            </div>
          </div>
          <span className="img mt-2 mb-3">
            <img src={HeartLine} width="25px" alt="favorite" />
          </span>
          <div className="bottom-box-price-details mt-auto">
            <div className="bottom-box">
              <ul className="top-adult list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li>{t("stayDuration")}, </li>
                <li>{t("guests")}</li>
              </ul>
              <ul className="price-details list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li className="old-price">₹ 3,306</li>
                <li className="current-price">₹ 1,587</li>
              </ul>
              <span>{t("taxesFees")}</span>
              <Link to="/hotel-details" className="btn btn-primary">
                {t("viewDetails")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div className="trip-details trip-review-details p-12 d-flex mb-3 flex-lg-nowrap flex-wrap">
      <div className="left-review-details d-flex flex-wrap gap-2">
        <div className="img-review">
          <img src={Still02} alt={t("hotelAlt")} />
        </div>
        <div className="text-review">
          <Link to="hotel-details.html" className="btn-details-sec">
            <h2>{t("hotelName")}</h2>
          </Link>
          <div className="heart-text d-flex align-items-center gap-2">
            <span>{t("hotelLocation")}</span>
          </div>
          <div className="btn-box-mid">
            <Link to="#" className="btn btn-parrot">
              {t("limitedDeal")}
            </Link>
          </div>
          <div className="room-details">
            <p>{t("roomType")}</p>
            <ul className="list-item-dot">
              <li>{t("bedType")}</li>
            </ul>
            <p>{t("paymentPolicy")}</p>
          </div>
        </div>
      </div>
      <div className="right-review-details">
        <div className="review-right-com d-flex flex-column h-100 text-end">
          <div className="top-box-review">
            <div className="room-servic">
              <span className="review-text">{t("reviewText")}</span>
              <span className="review-btn"></span>
            </div>
          </div>
          <span className="img mt-2 mb-3">
            <img src={HeartLine} width="25px" alt="favorite" />
          </span>
          <div className="bottom-box-price-details mt-auto">
            <div className="bottom-box">
              <ul className="top-adult list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li>{t("stayDuration")}, </li>
                <li>{t("guests")}</li>
              </ul>
              <ul className="price-details list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li className="old-price">₹ 3,306</li>
                <li className="current-price">₹ 1,587</li>
              </ul>
              <span>{t("taxesFees")}</span>
              <Link to="/hotel-details" className="btn btn-primary">
                {t("viewDetails")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div className="trip-details trip-review-details p-12 d-flex mb-3 flex-lg-nowrap flex-wrap">
      <div className="left-review-details d-flex flex-wrap gap-2">
        <div className="img-review">
          <img src={Still02} alt={t("hotelAlt")} />
        </div>
        <div className="text-review">
          <Link to="hotel-details.html" className="btn-details-sec">
            <h2>{t("hotelName")}</h2>
          </Link>
          <div className="heart-text d-flex align-items-center gap-2">
            <span>{t("hotelLocation")}</span>
          </div>
          <div className="btn-box-mid">
            <Link to="#" className="btn btn-parrot">
              {t("limitedDeal")}
            </Link>
          </div>
          <div className="room-details">
            <p>{t("roomType")}</p>
            <ul className="list-item-dot">
              <li>{t("bedType")}</li>
            </ul>
            <p>{t("paymentPolicy")}</p>
          </div>
        </div>
      </div>
      <div className="right-review-details">
        <div className="review-right-com d-flex flex-column h-100 text-end">
          <div className="top-box-review">
            <div className="room-servic">
              <span className="review-text">{t("reviewText")}</span>
              <span className="review-btn"></span>
            </div>
          </div>
          <span className="img mt-2 mb-3">
            <img src={HeartLine} width="25px" alt="favorite" />
          </span>
          <div className="bottom-box-price-details mt-auto">
            <div className="bottom-box">
              <ul className="top-adult list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li>{t("stayDuration")}, </li>
                <li>{t("guests")}</li>
              </ul>
              <ul className="price-details list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li className="old-price">₹ 3,306</li>
                <li className="current-price">₹ 1,587</li>
              </ul>
              <span>{t("taxesFees")}</span>
              <Link to="/hotel-details" className="btn btn-primary">
                {t("viewDetails")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div className="trip-details trip-review-details p-12 d-flex mb-3 flex-lg-nowrap flex-wrap">
      <div className="left-review-details d-flex flex-wrap gap-2">
        <div className="img-review">
          <img src={Still02} alt={t("hotelAlt")} />
        </div>
        <div className="text-review">
          <Link to="hotel-details.html" className="btn-details-sec">
            <h2>{t("hotelName")}</h2>
          </Link>
          <div className="heart-text d-flex align-items-center gap-2">
            <span>{t("hotelLocation")}</span>
          </div>
          <div className="btn-box-mid">
            <Link to="#" className="btn btn-parrot">
              {t("limitedDeal")}
            </Link>
          </div>
          <div className="room-details">
            <p>{t("roomType")}</p>
            <ul className="list-item-dot">
              <li>{t("bedType")}</li>
            </ul>
            <p>{t("paymentPolicy")}</p>
          </div>
        </div>
      </div>
      <div className="right-review-details">
        <div className="review-right-com d-flex flex-column h-100 text-end">
          <div className="top-box-review">
            <div className="room-servic">
              <span className="review-text">{t("reviewText")}</span>
              <span className="review-btn"></span>
            </div>
          </div>
          <span className="img mt-2 mb-3">
            <img src={HeartLine} width="25px" alt="favorite" />
          </span>
          <div className="bottom-box-price-details mt-auto">
            <div className="bottom-box">
              <ul className="top-adult list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li>{t("stayDuration")}, </li>
                <li>{t("guests")}</li>
              </ul>
              <ul className="price-details list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li className="old-price">₹ 3,306</li>
                <li className="current-price">₹ 1,587</li>
              </ul>
              <span>{t("taxesFees")}</span>
              <Link to="/hotel-details" className="btn btn-primary">
                {t("viewDetails")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div className="trip-details trip-review-details p-12 d-flex mb-3 flex-lg-nowrap flex-wrap">
      <div className="left-review-details d-flex flex-wrap gap-2">
        <div className="img-review">
          <img src={Still02} alt={t("hotelAlt")} />
        </div>
        <div className="text-review">
          <Link to="hotel-details.html" className="btn-details-sec">
            <h2>{t("hotelName")}</h2>
          </Link>
          <div className="heart-text d-flex align-items-center gap-2">
            <span>{t("hotelLocation")}</span>
          </div>
          <div className="btn-box-mid">
            <Link to="#" className="btn btn-parrot">
              {t("limitedDeal")}
            </Link>
          </div>
          <div className="room-details">
            <p>{t("roomType")}</p>
            <ul className="list-item-dot">
              <li>{t("bedType")}</li>
            </ul>
            <p>{t("paymentPolicy")}</p>
          </div>
        </div>
      </div>
      <div className="right-review-details">
        <div className="review-right-com d-flex flex-column h-100 text-end">
          <div className="top-box-review">
            <div className="room-servic">
              <span className="review-text">{t("reviewText")}</span>
              <span className="review-btn"></span>
            </div>
          </div>
          <span className="img mt-2 mb-3">
            <img src={HeartLine} width="25px" alt="favorite" />
          </span>
          <div className="bottom-box-price-details mt-auto">
            <div className="bottom-box">
              <ul className="top-adult list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li>{t("stayDuration")}, </li>
                <li>{t("guests")}</li>
              </ul>
              <ul className="price-details list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li className="old-price">₹ 3,306</li>
                <li className="current-price">₹ 1,587</li>
              </ul>
              <span>{t("taxesFees")}</span>
              <Link to="/hotel-details" className="btn btn-primary">
                {t("viewDetails")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div className="trip-details trip-review-details p-12 d-flex mb-3 flex-lg-nowrap flex-wrap">
      <div className="left-review-details d-flex flex-wrap gap-2">
        <div className="img-review">
          <img src={Still02} alt={t("hotelAlt")} />
        </div>
        <div className="text-review">
          <Link to="hotel-details.html" className="btn-details-sec">
            <h2>{t("hotelName")}</h2>
          </Link>
          <div className="heart-text d-flex align-items-center gap-2">
            <span>{t("hotelLocation")}</span>
          </div>
          <div className="btn-box-mid">
            <Link to="#" className="btn btn-parrot">
              {t("limitedDeal")}
            </Link>
          </div>
          <div className="room-details">
            <p>{t("roomType")}</p>
            <ul className="list-item-dot">
              <li>{t("bedType")}</li>
            </ul>
            <p>{t("paymentPolicy")}</p>
          </div>
        </div>
      </div>
      <div className="right-review-details">
        <div className="review-right-com d-flex flex-column h-100 text-end">
          <div className="top-box-review">
            <div className="room-servic">
              <span className="review-text">{t("reviewText")}</span>
              <span className="review-btn"></span>
            </div>
          </div>
          <span className="img mt-2 mb-3">
            <img src={HeartLine} width="25px" alt="favorite" />
          </span>
          <div className="bottom-box-price-details mt-auto">
            <div className="bottom-box">
              <ul className="top-adult list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li>{t("stayDuration")}, </li>
                <li>{t("guests")}</li>
              </ul>
              <ul className="price-details list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li className="old-price">₹ 3,306</li>
                <li className="current-price">₹ 1,587</li>
              </ul>
              <span>{t("taxesFees")}</span>
              <Link to="/hotel-details" className="btn btn-primary">
                {t("viewDetails")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div className="trip-details trip-review-details p-12 d-flex mb-3 flex-lg-nowrap flex-wrap">
      <div className="left-review-details d-flex flex-wrap gap-2">
        <div className="img-review">
          <img src={Still02} alt={t("hotelAlt")} />
        </div>
        <div className="text-review">
          <Link to="hotel-details.html" className="btn-details-sec">
            <h2>{t("hotelName")}</h2>
          </Link>
          <div className="heart-text d-flex align-items-center gap-2">
            <span>{t("hotelLocation")}</span>
          </div>
          <div className="btn-box-mid">
            <Link to="#" className="btn btn-parrot">
              {t("limitedDeal")}
            </Link>
          </div>
          <div className="room-details">
            <p>{t("roomType")}</p>
            <ul className="list-item-dot">
              <li>{t("bedType")}</li>
            </ul>
            <p>{t("paymentPolicy")}</p>
          </div>
        </div>
      </div>
      <div className="right-review-details">
        <div className="review-right-com d-flex flex-column h-100 text-end">
          <div className="top-box-review">
            <div className="room-servic">
              <span className="review-text">{t("reviewText")}</span>
              <span className="review-btn"></span>
            </div>
          </div>
          <span className="img mt-2 mb-3">
            <img src={HeartLine} width="25px" alt="favorite" />
          </span>
          <div className="bottom-box-price-details mt-auto">
            <div className="bottom-box">
              <ul className="top-adult list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li>{t("stayDuration")}, </li>
                <li>{t("guests")}</li>
              </ul>
              <ul className="price-details list-unstyled p-0 m-0 d-flex align-items-center gap-1 justify-content-end">
                <li className="old-price">₹ 3,306</li>
                <li className="current-price">₹ 1,587</li>
              </ul>
              <span>{t("taxesFees")}</span>
              <Link to="/hotel-details" className="btn btn-primary">
                {t("viewDetails")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    </>
  )
}

export default HotelList